import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Provider } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ReviewBaseComponent } from '@luggagehero/features/bookings';
import { SurveyService } from '@luggagehero/services';
import { SharedIntercomService } from '@luggagehero/shared/services/intercom';
import { SharedReviewsService } from '@luggagehero/shared/services/reviews';
import { SharedUserService } from '@luggagehero/shared/services/users';

export const REVIEW_CONTROL_VALUE_ACCESSOR: Provider = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => ReviewComponent),
  multi: true,
};

@Component({
  selector: 'lh-review',
  templateUrl: './review.component.html',
  styleUrls: ['./review.component.scss'],
  providers: [REVIEW_CONTROL_VALUE_ACCESSOR],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReviewComponent extends ReviewBaseComponent {
  constructor(
    cd: ChangeDetectorRef,
    reviewsService: SharedReviewsService,
    userService: SharedUserService,
    surveyService: SurveyService,
    intercomService: SharedIntercomService,
  ) {
    super(cd, reviewsService, userService, surveyService, intercomService);
  }
}
